// @ts-check

import { URL_COMPLETE_INTRO } from 'constants/urls';

/**
 * @async
 * @function completeIntro
 * @desc Marks the intro walkthrough (CANapps Home Tour) as seen for the current
 * user so it won't auto-start again. Fire-and-forget: failures are swallowed —
 * worst case the intro simply re-triggers on the next login.
 * @returns {Promise<void>}
 */
async function completeIntro() {
	try {
		// POST (not GET): CompleteIntro is a mutating ASMX ScriptMethod and
		// rejects GET. Empty JSON body for the parameterless method.
		const res = await fetch(URL_COMPLETE_INTRO, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'Cache-Control': 'no-cache',
			},
			body: '{}',
			credentials: 'include',
		});
		if (!res.ok) {
			console.warn('[completeIntro] non-OK response:', res.status);
		}
	} catch (error) {
		console.warn('[completeIntro] failed (will retry next login):', error);
	}
}

export default completeIntro;
